module.exports = __webpack_public_path__ + "static/media/icon-whatsapp.3e8e8a20.webp";